export default "__VITE_ASSET__qVmN1MNx__"